import React from "react";

const getYoutubeId = (url) => {
  if (!url) return null;

  const regex =
    /(?:youtube.com\/(?:watch\?v=|embed\/|shorts\/)|youtu.be\/)([^&?/]+)/;

  const match = url.match(regex);

  return match ? match[1] : null;
};

const ServiceVideos = ({ videos = [] }) => {
  if (!videos || videos.length === 0) {
    return null;
  }

  const validVideos = videos.filter(
    (video) => getYoutubeId(video.youtube_url)
  );

  if (!validVideos.length) {
    return null;
  }

  return (
    <section className="relative overflow-hidden bg-[#DCE4EC] py-16 md:py-20">

      {/* Soft decorative background */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 -left-32 w-72 h-72 rounded-full bg-white/30 blur-3xl" />
        <div className="absolute -bottom-40 -right-32 w-96 h-96 rounded-full bg-[#1E3A5F]/5 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">

        {/* Header */}
        <div className="text-center mb-12 md:mb-14">

          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#1E3A5F] mb-4">
            <span className="w-8 h-px bg-[#1E3A5F]/40" />

            Video Documentation

            <span className="w-8 h-px bg-[#1E3A5F]/40" />
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1F2937] leading-tight">
            Behind the Scenes & Event Highlights
          </h2>

          <p className="text-sm md:text-base text-[#6B7280] mt-4 max-w-2xl mx-auto leading-7">
            Explore selected behind-the-scenes moments and event highlights from projects we have brought to life.
          </p>

        </div>

        {/* Videos */}
        <div
          className={`
            grid
            gap-6
            ${
              validVideos.length === 1
                ? "grid-cols-1 max-w-2xl mx-auto"
                : validVideos.length === 2
                ? "grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto"
                : validVideos.length === 3
                ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto"
                : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
            }
          `}
        >

          {validVideos.map((video) => {

            const videoId = getYoutubeId(video.youtube_url);

            return (
              <div
                key={video.id}
                className="
                  group
                  overflow-hidden
                  rounded-2xl
                  bg-white
                  border border-[#E2E8F0]
                  shadow-[0_8px_25px_rgba(30,58,95,0.08)]
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:shadow-[0_14px_35px_rgba(30,58,95,0.14)]
                "
              >

                {/* Video */}
                <div className="relative aspect-video bg-[#E9EEF3] overflow-hidden">

                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title={video.title || "Video Documentation"}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />

                </div>

                {/* Title */}
                {video.title && (
                  <div className="px-5 py-4 md:px-6 md:py-5">

                    <h3 className="font-semibold text-[#1F2937] text-sm md:text-[15px] leading-6">
                      {video.title}
                    </h3>

                  </div>
                )}

              </div>
            );
          })}

        </div>

      </div>

      {/* Bottom separator */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-[#1E3A5F]/10" />

    </section>
  );
};

export default ServiceVideos;